import store from "@/store";
import requestService from "@/service/requestService";

export class InspectionDetailService {
  reqService: requestService;

  constructor() {
    this.reqService = new requestService();
  }

  getInspectionDetailDataPM(uketsukeExtendsId: number) {
    const promise = new Promise((resolve, reject) => {
      this.reqService
      .getInsectionDetail(uketsukeExtendsId)
      .then((data: any) => {
          resolve(data);
        },
        (err: any) => {
          reject(err);
        }
      );
    });

    return promise;
  }

  public getInspectionDetail(uketsukeExtendsId: number) {
    const promise = this.getInspectionDetailDataPM(uketsukeExtendsId);
    Promise.all([promise]).then((res: any) => {
      if (res && res.length > 0) {
        const data = res[0];
        store.dispatch("InspectionDetail/setSeibiMenuCd", data.shakenShuruiSeibiMenuCd);
        store.dispatch("InspectionDetail/setShakenShuruiNm", data.shakenShuruiNm);
        store.dispatch("InspectionDetail/setShakenShuruiSeibiMenuUpdatedAt", data.shakenShuruiSeibiMenuUpdatedAt);
        store.dispatch("InspectionDetail/setJizenCd", data.jizenCd);
      }
    });
  }
}
